String.prototype.replaceAll = function(find, replace) {
	return this.replace(new RegExp(find, 'g'), replace);
};

String.prototype.stripCommas = function() {
	return this.replaceAll(',', '');
};

String.prototype.titleize = function() {
	return this.replace(/_/g, ' ')
		.split(' ')
	    .map(word => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase())
	    .join(' ');
};

String.prototype.camelCase = function() {
	let w = this.replace(/_/g, ' ')
		.split(' ')
		.map(word => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase())
		.join('');
	return w = w.charAt(0).toLowerCase() + w.substr(1);
};
